import Additives from './Additives';
import Allergens from './Allergens';
import CompanyTiers from './CompanyTiers';
import Constants from './Constants';
import ConsumerInvoices from './ConsumerInvoices';
import Roles from './Roles';
import DietaryAttributes from './DietaryAttributes';
import DeliveryProviders from './DeliveryProviders';
import MasterProvider from './MasterProvider';
import MerchantBilling from './MerchantBilling';
import OrderMethods from './OrderMethods';
import PlgOnboarding from './PlgOnboarding';

export default {
  Additives,
  Allergens,
  CompanyTiers,
  Constants,
  ConsumerInvoices,
  Roles,
  DietaryAttributes,
  DeliveryProviders,
  MasterProvider,
  MerchantBilling,
  OrderMethods,
  PlgOnboarding,
};
